import './CalendarRange.scss';

interface CalendarRangeOptions {
    dateFormat: string;
    startDate: string;
    endDate: string;
    minDateTimestamp: number | null;
    maxDateTimestamp: number | null;
}

interface CalendarRangeCallbacks {
    onChange: (startDate: string, endDate: string) => void;
    onValidation: (valid: boolean) => void;
}

export class CalendarRange {
    
    private root: HTMLDivElement;
    private options: CalendarRangeOptions;
    private callbacks: CalendarRangeCallbacks;

    constructor(root: HTMLDivElement, options: CalendarRangeOptions, callbacks: CalendarRangeCallbacks) {
        this.root = root;
        this.options = options;
        this.callbacks = callbacks;
        this.init();
    }
    private updateText(text: string) {
        let el = this.root.querySelector('.js-date-text') as HTMLDivElement;
        if (el) el.innerHTML = text;
    }
    
    private init() {
        
        
        // @ts-ignore moment is not recognized
        let m = moment;
        m.locale('pl');
        
        // let dateFormat = 'YYYY-MM-DD';
        let startDate = m();
        let endDate = m();
        let minDate = null;
        let maxDate = null;
        
        if (m(this.options.startDate).isValid()) {
            startDate = m(this.options.startDate);
        }
        if (m(this.options.endDate).isValid()) {
            endDate = m(this.options.endDate);
        }
        
        if (m(this.options.minDateTimestamp).isValid()) {
            minDate = m(this.options.minDateTimestamp);
        }
        
        if (m(this.options.maxDateTimestamp).isValid()) {
            maxDate = m(this.options.maxDateTimestamp);
        }
        
        this.root.innerHTML = this.getHTML();
        
        // @ts-ignore daterangepicker is not recognized
        jQuery(this.root.querySelector('.js-date-range-div')).daterangepicker({
            alwaysShowCalendars: true,
            showCustomRangeLabel: false,
            minYear: 1990,
            maxYear: parseInt(m().format('YYYY'), 10),
            startDate: startDate,
            endDate: endDate,
            minDate: minDate,
            maxDate: maxDate,
            locale: {
                format: this.options.dateFormat,
                cancelLabel: 'Anuluj',
                applyLabel: 'Zastosuj',
                "daysOfWeek": [
                    "Nd",
                    "Pn",
                    "Wt",
                    "Śr",
                    "Cz",
                    "Pt",
                    "So"
                ],
                "monthNames": [
                    "Styczeń",
                    "Luty",
                    "Marzec",
                    "Kwiecień",
                    "Maj",
                    "Czerwiec",
                    "Lipiec",
                    "Sierpień",
                    "Wrzesień",
                    "Październik",
                    "Listopad",
                    "Grudzień"
                ],
                "firstDay": 1
            },
            applyClass: 'date-range-button-apply',
            cancelClass: 'date-range-button-cancel',
            ranges: {
                // 'Wczoraj': [m().subtract(1, 'days'), m().subtract(1, 'days')],
                'Dzisiaj': [m(), m()],
                'Jutro': [m().add(1, 'days'), m().add(1, 'days')],
                'Najbliższe 2 dni': [m(), m().add(1, 'days')],
                'Najbliższe 3 dni': [m(), m().add(2, 'days')],
                'Najbliższy tydzień': [m(), m().add(6, 'days')],
                // 'Ostatnie 7 dni': [m().subtract(6, 'days'), m()],
                // 'Ostatnie 30 dni': [m().subtract(29, 'days'), m()],
                // 'Bieżący miesiąc': [m().startOf('month'), m().endOf('month')],
                // 'Poprzedni miesiąc': [m().subtract(1, 'month').startOf('month'), m().subtract(1, 'month').endOf('month')]
            }
        }, (startDate: any, endDate: any) => {
            this.updateText(startDate.format(this.options.dateFormat) + ' - ' + endDate.format(this.options.dateFormat));
            this.callbacks.onValidation(true);
            // this.root.querySelector('.js-date-text').innerHTML = startDate.format(this.options.dateFormat) + ' - ' + endDate.format(this.options.dateFormat);
            this.callbacks.onChange(startDate, endDate);
        } );
        
        // @ts-ignore jQuery is not recognized
        jQuery('.daterangepicker').css('z-index', 20000000).css('box-shadow','-1px 11px 31px -10px rgba(0, 0, 0, 0.75)');
        
        if (m(this.options.startDate).isValid() && m(this.options.endDate).isValid()) {
            this.updateText(startDate.format(this.options.dateFormat) + ' - ' + endDate.format(this.options.dateFormat));
            this.callbacks.onValidation(true);
        } else {
            this.updateText('');
            this.callbacks.onValidation(false);
        }
    }
    
    private getHTML() {
        return `
            <div class="js-date-range-div" style="">
                <div class="js-date-calendar-icon"></div>
                <div class="js-date-text filter-input"></div> <i class="fa fa-caret-down"></i>
            </div>
            `;
    }

}